import clsx from 'clsx';
import styles from '../FiltersPanel.module.css';

const MODES = [
  { key: 'include', label: 'Include' },
  { key: 'exclude', label: 'Exclude' },
];

export function TagsModeToggle({ mode = 'include', onChange }) {
  return (
    <div className={clsx(styles.modeToggle)} role="group" aria-label="Tags filter mode">
      {MODES.map(({ key, label }) => {
        const isActive = mode === key;
        return (
          <button
            key={key}
            type="button"
            className={clsx(
              styles.modeTab,
              isActive && styles.modeTabActive,
              isActive && key === 'exclude' && styles.modeTabActiveExclude,
            )}
            aria-pressed={isActive}
            onClick={() => onChange?.(key)}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}
